(function () {
  function rowsFromSetups(data) {
    if (Array.isArray(data)) {
      return data
        .map((row) => {
          if (!row || typeof row !== "object") return null;
          const label = row.label != null ? String(row.label) : "";
          const detail = row.detail != null ? String(row.detail) : "";
          if (!label && !detail) return null;
          return { label, detail };
        })
        .filter(Boolean);
    }
    if (data && typeof data === "object") {
      return Object.keys(data).map((label) => ({
        label: String(label),
        detail: data[label] == null ? "" : String(data[label]),
      })).filter((row) => row.label || row.detail);
    }
    return [];
  }

  function hydrate(ul) {
    const script = ul.querySelector('script[type="application/json"]');
    if (!script) return;
    let data;
    try {
      data = JSON.parse(script.textContent || "null");
    } catch (_err) {
      script.remove();
      return;
    }
    script.remove();
    const rows = rowsFromSetups(data);
    if (!rows.length) {
      ul.remove();
      return;
    }
    const frag = document.createDocumentFragment();
    rows.forEach((row) => {
      const li = document.createElement("li");
      li.className = "kc-community__setup";
      const strong = document.createElement("strong");
      strong.textContent = row.label;
      const span = document.createElement("span");
      span.textContent = row.detail;
      li.appendChild(strong);
      li.appendChild(span);
      frag.appendChild(li);
    });
    ul.appendChild(frag);
  }

  document.querySelectorAll("[data-kc-setups]").forEach(hydrate);
})();
